"use strict";
/**
 * Created by rouven on 15.03.17.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var types = __importStar(require("../actions/actionTypes"));
/**
 * Returns the initial request state for the passed url
 * @private
 * @param url {string} the url for the request
 */
var initialRequestState = function (url) { return ({
    url: url,
    isQueued: false,
    isPending: true,
    isComplete: false,
    percent: 0
}); };
/**
 * Handles  pending  data  requests  and  cancelation  of  such.   Also  handles  REFRESH_DATA,  CLEAR_DATA and LOAD_DATA_PROGRESS actions.
 * Sets internal properties of the state, that are used to determine thestate of the request (e.g.  isPending or percent).
 * @public
 * @param state {object} the current state
 * @param action {object} the dispatched action
 * @returns {object} the next state
 */
var queriesReducer = function (state, action) {
    var _a, _b, _c, _d;
    if (state === void 0) { state = {}; }
    switch (action.type) {
        case types.LOAD_DATA_PENDING: {
            return Object.assign({}, state, (_a = {},
                _a[action.name] = initialRequestState(action.url),
                _a));
        }
        case types.LOAD_DATA_SUCCESS:
        case types.LOAD_DATA_FAILURE: {
            var requestState = state[action.name] ? Object.assign({}, state[action.name]) : initialRequestState(action.url);
            requestState.isPending = false;
            requestState.isComplete = true;
            requestState.percent = 100;
            return Object.assign({}, state, (_b = {},
                _b[action.name] = requestState,
                _b));
        }
        case types.LOAD_DATA_CANCEL: {
            var nextState = Object.assign({}, state);
            delete nextState[action.name];
            return nextState;
        }
        case types.LOAD_DATA_PROGRESS: {
            var requestState = state[action.name] ? Object.assign({}, state[action.name]) : initialRequestState(action.url);
            requestState.percent = action.percent;
            return Object.assign({}, state, (_c = {},
                _c[action.name] = requestState,
                _c));
        }
        case types.REFRESH_DATA: {
            var requestState = state[action.name] ? Object.assign({}, state[action.name]) : initialRequestState(action.url);
            requestState.isQueued = true;
            requestState.isPending = false;
            requestState.isComplete = false;
            requestState.percent = 0;
            return Object.assign({}, state, (_d = {},
                _d[action.name] = requestState,
                _d));
        }
        case types.CLEAR_DATA: {
            var nextState = Object.assign({}, state);
            delete nextState[action.name];
            return nextState;
        }
        default:
            return state;
    }
};
exports["default"] = queriesReducer;
